import { api, authHeader } from "../configs/axiosConfigs";

const resolveBaseUrl = (source) =>
  source === "Management"
    ? "/SLN/Management/LendingWorkQueue"
    : "/SLN/SolarentOperator/LendingWorkQueue";

const LendingWorkQueueApi = {
  getFilterData: async (source = "SolarentOperator", partnerCode) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/GetFilterData`,
      method: "GET",
      headers: authHeader(),
      params: { partnerCode },
    });
    return response.data;
  },

  search: async (source = "SolarentOperator", partnerCode, searchParams = {}) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/Search`,
      method: "POST",
      headers: authHeader(),
      data: { partnerCode, ...searchParams },
    });
    return response.data;
  },

  assign: async (
    source = "SolarentOperator",
    loanProcessId,
    assignedToUserId = null
  ) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/Assign`,
      method: "POST",
      headers: authHeader(),
      data: { loanProcessId, assignedToUserId },
    });
    return response.data;
  },
};

export default LendingWorkQueueApi;
